import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["currency", "money"]

  connect() {
    this.refreshMoney()
  }

  refreshMoney() {
    const denomination = this.hasCurrencyTarget && this.currencyTarget.checked ? "proposedCurrency" : "currentCurrency"
    for (const money of this.moneyTargets) money.textContent = money.dataset[denomination]
  }
}
